export default {
  groupActivity:{
    tab1:'推荐群组',
    tab2:'审核',
    tab3:'分类',

    group_id:'群组ID',
    group_owner:'群主ID',
    recommendData:"推荐时间",
    group_name:'群组名称',
    class:'分类',

    tableText1:'群主国籍',
    tableText2:'推荐时人数',
    tableText3:'当前人数',
    tableText4:'点赞数',
    tableText5:'宣传文案',
    tableText6:'宣传图',
    tableText7:'本周聊天数量',
    tableText8:'人数（推荐时/当前）',
    add_time:'申请时间',

    closeRecom:'结束推荐',
    editContent:'编辑宣传文案',
    status:'状态',


  }
}



// WEBPACK FOOTER //
// ./src/language/groupActivity-zh-cn.js